import { render, staticRenderFns } from "./checkout-total.vue?vue&type=template&id=ebd82776&"
import script from "./checkout-total.vue?vue&type=script&lang=js&"
export * from "./checkout-total.vue?vue&type=script&lang=js&"
import style0 from "./checkout-total.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd82776')) {
      api.createRecord('ebd82776', component.options)
    } else {
      api.reload('ebd82776', component.options)
    }
    module.hot.accept("./checkout-total.vue?vue&type=template&id=ebd82776&", function () {
      api.rerender('ebd82776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-total/checkout-total.vue"
export default component.exports